export default __webpack_public_path__ + "static/media/proof5.3cb7a6b5.png";